// extracted by mini-css-extract-plugin
export default {"cvError":"J7-z"};